module.exports = new __parcel__URL__("TetherLogo.85e85692.svg").toString();